import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import BookingRequestStore from 'stores/plugins/booking_request';
import BookingRequestActionCreator from 'action_creators/booking_request';
import classnames from 'classnames';
import Input from 'views/ui/form_elements/input';
import { t } from 'services/translation';
import './index.scss';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';

class Discount extends React.Component {
  static displayName = 'Discount';

  static propTypes = {
    additionalParams: PropTypes.object.isRequired,
    errors: PropTypes.object,
    discountApplied: PropTypes.bool.isRequired,
    discountLoading: PropTypes.bool.isRequired,
    discountCode: PropTypes.string,
  };

  componentDidMount() {
    BookingRequestStore.changed.add(this._bookingRequestChanged);
  }

  componentWillUnmount() {
    BookingRequestStore.changed.remove(this._bookingRequestChanged);
  }

  _bookingRequestChanged = () => {
    const discountApplied = BookingRequestStore.state.get('discountApplied');

    if (this.state.discountApplied !== discountApplied) {
      this.setState({ discountApplied }, this._fetchSummary);
    }
  };

  errorMessages = () => {
    if (this.state.clientSideErrors.length > 0) {
      return this.state.clientSideErrors;
    } else if (this.props.errors !== undefined) {
      return this.props.errors.toJS();
    }
    return [];
  };

  initialDiscountCode = () => {
    if (this.props.discountCode !== undefined) {
      return this.props.discountCode;
    }
    return null;
  };

  expand = () => {
    this.setState({
      value: null,
      expanded: !this.state.expanded,
    });
  };

  onChange = (fieldName, newValue) => {
    this.setState({ value: newValue });
  };

  onSubmit = () => {
    const discountCode = this.state.value;

    if (discountCode === null || discountCode.trim() === '') {
      this.setState({
        clientSideErrors: [t('CANT_BE_BLANK')],
      });
      return;
    }
    this.setState({
      clientSideErrors: [],
    });

    if (!this.props.discountLoading) {
      this._applyCode(discountCode);
    }
  };

  _applyCode = (discountCode) => {
    const params = _.extend(
      {
        discount_code: discountCode.trim(),
      },
      this.props.additionalParams
    );

    BookingRequestActionCreator.applyDiscount(params);
  };

  _removeCode = () => {
    if (!this.props.discountLoading) {
      BookingRequestActionCreator.removeDiscount(this.props.additionalParams);
    }
  };

  _fetchSummary = () => {
    BookingRequestActionCreator.fetchSummary(this.props.additionalParams.id);
  };

  handleOnKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Space') {
      e.preventDefault();
      this.expand();
    }
  };

  _renderDiscountInput = () => {
    const btnClasses = classnames(
      'ui',
      { loading: this.props.discountLoading },
      'button'
    );

    const iconClasses = classnames('icon', 'anyfont-icon', {
      'af-promo-plus': !this.state.expanded,
      'af-promo-minus': this.state.expanded,
    });

    const { expanded } = this.state;

    return (
      <>
        <div className="DiscountCode-Title">
          <button
            type="button"
            className={iconClasses}
            aria-expanded={expanded}
            onClick={this.expand}
            aria-label={expanded ? 'Expanded' : 'Collapsed'}
            onKeyDown={(e) => this.handleOnKeyDown(e)}
            data-testid="promo-icon"
          />
          <span className="label">{t('REDEEM_PROMO_CODE')}</span>
        </div>
        <div className="DiscountCode-Input row">
          <Input
            name="discount_code"
            placeholder={t('ENTER_PROMO_CODE')}
            errors={this.errorMessages()}
            onChange={this.onChange}
            data-testid="enter-promo-code"
          />
          <button
            type="button"
            className={btnClasses}
            onClick={this.onSubmit}
            onKeyDown={(e) => !e.key.includes('Tab') && this.onSubmit()}
            data-testid="apply-button"
          >
            {t('APPLY')}
          </button>
        </div>
      </>
    );
  };

  _renderAppliedDiscountCode = () => {
    const { value } = this.state;

    return (
      <div className="DiscountCode-applied">
        <i className="icon af-checkmark brand-bg" />
        <div className="copy" data-testid="promo-code-applied">
          {' '}
          {t('PROMO_CODE_APPLIED')}
        </div>
        <div className="code">
          <span>{value}</span>
          <br />
          <button
            className="DiscountCode-remove brand-color"
            onClick={this._removeCode}
            type="button"
            onKeyDown={(e) => isActionKey(e.key) && this._removeCode()}
          >
            {t('REMOVE')}
          </button>
        </div>
      </div>
    );
  };

  state = {
    value: this.initialDiscountCode(),
    expanded: false,
    clientSideErrors: [],
    discountApplied: this.props.discountApplied,
  };

  render() {
    const containerClasses = classnames(
      'DiscountCodeContainer',
      'CheckoutSection',
      {
        expanded: this.state.expanded,
        'no-bottom-border': !!this.props.borderless,
        't-mobile': this.props.theme === 'mobile',
      }
    );

    return (
      <div className={containerClasses}>
        {this.props.discountApplied
          ? this._renderAppliedDiscountCode()
          : this._renderDiscountInput()}
      </div>
    );
  }
}

export default Discount;
